const vars = {
  tileWidth: 315,
  homeWhatsOntileWidth: 288,
  imageHeight: 173
}

export default vars
